import { render } from "./SubmitButterBar.vue?vue&type=template&id=9edb0cbe&scoped=true&ts=true"
import script from "./SubmitButterBar.vue?vue&type=script&lang=ts"
export * from "./SubmitButterBar.vue?vue&type=script&lang=ts"

import "./SubmitButterBar.vue?vue&type=style&index=0&id=9edb0cbe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9edb0cbe"]])

export default __exports__